var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container-with-title',{attrs:{"title":"Marcas","subtitle":_vm.subtitle}},[_c('v-brands-search'),_c('v-brands-table')],1)}
var staticRenderFns = []

export { render, staticRenderFns }